import { render, staticRenderFns } from "./TestTeacherHistoryHeader.vue?vue&type=template&id=7eb85c34&scoped=true&lang=pug&"
import script from "./TestTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./TestTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TestTeacherHistoryHeader.vue?vue&type=style&index=0&id=7eb85c34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb85c34",
  null
  
)

export default component.exports